import { useInfiniteQuery } from '@tanstack/react-query'

import axiosInstance from '@/libs/configs/axios'

export enum ESurveyHistoryStatus {
  IN_PROGRESS = 'IN_PROGRESS',
  IN_REVIEW = 'IN_REVIEW',
  APPROVED = 'APPROVED',
  CANCELLED = 'CANCELLED',
  REJECTED = 'REJECTED',
  SCREEN_OUT = 'SCREEN_OUT',
  AUTO_DISQUALIFIED = 'AUTO_DISQUALIFIED',
}

export type TListSurveyHistoryPayload = {
  pageParam: number
}

export type TSurveyHistoryData = {
  id: string
  name: string
  status: ESurveyHistoryStatus
  completedAt: Date
}

export type TListSurveyHistoryResult = {
  success: boolean
  traceId: string
  error?: {
    code: string
    message: string
    errors: any[]
  }
  metadata: {
    page: number
    limit: number
    total: number
  }
  result: {
    data: TSurveyHistoryData[]
  }
}

async function getListSurveyHistoryAPI(
  { pageParam }: TListSurveyHistoryPayload,
  useMockServer: boolean = false,
): Promise<TListSurveyHistoryResult> {
  try {
    const result = await axiosInstance({
      baseURL: useMockServer
        ? process.env.NEXT_PUBLIC_MOCK_API_URL
        : process.env.NEXT_PUBLIC_API_URL,
      url: `/submission/user/history`,
      method: 'get',
      params: {
        limit: 10,
        page: pageParam,
      },
    })

    return result?.data
  } catch (error: any) {
    throw error?.response?.data
  }
}

export default function useGetListSurveyHistoryQuery() {
  const { data, isError, error, fetchNextPage, hasNextPage, isFetchingNextPage, isPending } =
    useInfiniteQuery({
      queryKey: ['get_list_survey_history'],
      queryFn: getListSurveyHistoryAPI,
      initialPageParam: 1,
      getNextPageParam: (lastPage) => {
        const nextPage = lastPage?.metadata?.page + 1
        return nextPage <= Math.ceil(lastPage?.metadata?.total / lastPage?.metadata?.limit)
          ? nextPage
          : undefined
      },
    })

  return {
    data,
    isError,
    error,
    fetchNextPage,
    hasNextPage,
    isFetchingNextPage,
    isPending,
  }
}
